





















import Vue from 'vue';
import { isServiceRoleMode } from '../config';
import UserRolesList from './UserRolesList.vue';
import UserServiceRolesList from './UserServiceRolesList.vue';

export default Vue.extend({
  components: { UserRolesList, UserServiceRolesList },
  props: {
    userId: {
      type: String,
      required: true,
    },
    showAssignable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isServiceRoleMode(): boolean {
      return isServiceRoleMode();
    },
  },
});
